export const lateralMenu = [
  {
    text: 'Mi Campus',
    link: '/campus/myAcademies',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/miCampus2x.png',
    width: '30px',
    height: '27px',
    linkOption: 'campus'
  },
  {
    text: 'Revisor de actividades',
    link: '/evaluator',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/checkMenu.png',
    width: '30px',
    height: '27px',
    linkOption: 'evaluator'
  },
  {
    text: 'Mis Diplomas',
    link: '/myPortfolio',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/MisDiplomasV2.png',
    width: '30px',
    height: '30px',
    linkOption: 'myPortfolio'
  },
  {
    text: 'Edu Store',
    link: '/store',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_eduSStore.png',
    width: '36px',
    height: '30px',
    linkOption: 'store'
  }
];

export const lateralBottomMenu = [
  {
    text: 'Centro de ayuda',
    link: 'http://ayuda.mayahii.com/',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/centroAyuda2x.png',
    width: '22px',
    height: '30px',
    externalLink: true
  },
  {
    text: 'Tesorería',
    link: '/treasury',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/tesoreria2x.png',
    width: '26px',
    height: '30px',
    linkOption: 'treasury'
  },
  {
    text: 'Mi cuenta',
    link: '/myAccount/profile',
    icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/miCuenta.png',
    width: '35px',
    height: '32px',
    linkOption: 'myAccount'
  }
];
